import WordSetting from "./WordSetting";
import SentenceSetting from "./SentenceSetting";
import VideoSetting from "./VideoSetting";
import { Button } from "shared/components/Button";
import useSettingView from "features/homework/hooks/useSettingView";
import { setting } from "shared/types/Report";
import Modal from "shared/components/Modal";
import WordSettingViewer from "./WordSettingViewer";
import SentenceSettingViewer from "./SentenceSettingViewer";
import VideoSettingViewer from "./VideoSettingViewer";
import {
    EmptyState, EmptyTitle, EmptyText, ActionBar, ActionHint,
    EditorShell, EditorHeader, EditorTitle, EditorDesc, EditorBody, CountBadge
} from "../homeworkUi";

interface SettingViewProps{
    hasWordReport:boolean,
    hasSentenceReport:boolean,
    hasVideoReport:boolean,
    path:string,
    setting:setting,
    viewer?:boolean,
    setSetting:React.Dispatch<React.SetStateAction<setting>>,
    onRegisterAllClickHandler:() => void,
    isRegisterSucceed:boolean,
    onRegisterSucceedModalConfirmHandler:() => void,
    isRegisterFailed:boolean,
    onRegisterFaildModalConfirmHandler:() => void
}

const SettingView = ({setting, setSetting ,hasWordReport, hasSentenceReport, hasVideoReport, onRegisterAllClickHandler, isRegisterSucceed, isRegisterFailed, onRegisterSucceedModalConfirmHandler, onRegisterFaildModalConfirmHandler, viewer}:SettingViewProps) => {
    const {onSettingChangeHandler} = useSettingView(setSetting);
    const contentCount = [hasWordReport, hasSentenceReport, hasVideoReport].filter(Boolean).length;

    const viewOptions = (name:string, max:number, unit:string) => {
        const option_list:any = [];

        for(let i = 1; i <= max; i++){
            const value = unit === "%" ? i * 10 : i
            option_list.push(<option key={i} value={value}>{`${name} ${value}${unit}`}</option>)
        }
        return option_list;
    }

    const viewSetting = () => {
        const view_list:any[] = [];
        if(hasWordReport){
            view_list.push(<WordSetting key={1} viewOptions={viewOptions} setting={setting} onSettingChangeHandler={onSettingChangeHandler}/>);
        }
        if(hasSentenceReport){
            view_list.push(<SentenceSetting key={2} viewOptions={viewOptions} setting={setting} onSettingChangeHandler={onSettingChangeHandler}/>);
        }
        if(hasVideoReport){
            view_list.push(<VideoSetting key={3} viewOptions={viewOptions} setting={setting} onSettingChangeHandler={onSettingChangeHandler}/>);
        }
        return view_list;
    }

    const viewerSetting = () => {
        const view_list:any[] = [];
        if(hasWordReport){
            view_list.push(<WordSettingViewer key={1} viewOptions={viewOptions} setting={setting}/>);
        }
        if(hasSentenceReport){
            view_list.push(<SentenceSettingViewer key={2} viewOptions={viewOptions} setting={setting}/>);
        }
        if(hasVideoReport){
            view_list.push(<VideoSettingViewer key={3} viewOptions={viewOptions} setting={setting} />);
        }
        return view_list;
    }

    return(
        <EditorShell>
            <Modal isOpen={isRegisterSucceed} onClose={onRegisterSucceedModalConfirmHandler} title="등록 성공" content="과제 등록에 성공하였습니다<br/>과제를 배포할 수 있습니다"/>
            <Modal isOpen={isRegisterFailed} onClose={onRegisterFaildModalConfirmHandler} title="ERROR" content="과제 등록중 오류가 발생하였습니다<br/>다시 시도해 주세요"/>
            <EditorHeader>
                <div>
                    <EditorTitle>학습 설정</EditorTitle>
                    <EditorDesc>
                        {viewer
                            ? "등록된 콘텐츠별 학습 방식을 확인합니다."
                            : "콘텐츠별 학습 방식을 고른 뒤 등록을 완료하면 배포할 수 있습니다."}
                    </EditorDesc>
                </div>
                {contentCount ? <CountBadge>{contentCount}종</CountBadge> : null}
            </EditorHeader>
            <EditorBody>
                {contentCount ? (viewer ? viewerSetting() : viewSetting()) : (
                    <EmptyState>
                        <EmptyTitle>{viewer ? "학습 설정이 없습니다" : "등록할 콘텐츠가 없습니다"}</EmptyTitle>
                        <EmptyText>
                            {viewer
                                ? "단어·문장·영상 콘텐츠가 등록된 과제에서 설정을 확인할 수 있습니다."
                                : "단어·문장·영상 탭에서 내용을 저장한 뒤, 여기에서 학습 설정을 하고 등록을 완료하세요."}
                        </EmptyText>
                    </EmptyState>
                )}
            </EditorBody>
            {!viewer && contentCount ? (
                <ActionBar>
                    <ActionHint>설정을 확인한 뒤 등록을 완료하면 배포할 수 있습니다.</ActionHint>
                    <Button name="등록" onButtonClick={onRegisterAllClickHandler}/>
                </ActionBar>
            ) : null}
        </EditorShell>
    )
}

export default SettingView;
